/**
 * Sube secili ama bu bolumu besleyen rapor subeye SUZULEMIYORSA, sayinin
 * neyi kapsadigini ACIKCA yazar. Sessizce firma geneli rakami basmak,
 * baslikta "ATAKENT" yazarken govdede tum firmayi gostermek olurdu -
 * ekranin en tehlikeli yalan bicimi budur.
 *
 * Sube secili DEGILSE ya da kaynak suzulebiliyorsa HICBIR SEY basmaz
 * (gurultu uretmez).
 */
export function KapsamNotu({ sube, destekli }: { sube: string | null; destekli: boolean }) {
  if (sube === null || destekli) return null;
  return (
    <span data-testid="kapsam-firma-geneli" className="text-[11px] text-ink-400 font-normal">
      {' '}· firma geneli (bu rapor şubeye ayrışmıyor)
    </span>
  );
}
